// Import Redux
import { AnyAction } from 'redux'
// Import Redux Types
import {
  DOWNLOAD_CREATOR_OFFERING_DATA,
  SUCCESS_DOWNLOAD_CREATOR_OFFERING_DATA,
  ERROR_DOWNLOAD_CREATOR_OFFERING_DATA,
  SEND_OFFERING,
  SUCCESS_SEND_OFFERING,
  ERROR_SEND_OFFERING,
  UPDATE_TEMPORAL_IMAGE,
  UPDATE_CONFIRMED_IMAGE,
  SHOW_CUTTER_IMAGE
} from '../types/index'



// State Reducer
const initialState = {
  error: false,
  isLoad: false,
  title: '',
  text: '',
  text2: '',
  options: '',
  temporalImage: {
    url: '',
    image: ''
  },
  confirmedImage: {
    url: '',
    image: ''
  },
  isCutterImageVisible: false,
  offeringCreated: {},
  isLogin: false,
  hasOffering: false
}



// Reducer
export default ( state = initialState, action:AnyAction ) => {
  switch( action.type ) {
    case DOWNLOAD_CREATOR_OFFERING_DATA:
      return {
        ...state,
        error: false,
        isLoad: true
      }
    case SEND_OFFERING:
      return {
        ...state,
        error: false,
        isLoad: true
      }
    case SUCCESS_DOWNLOAD_CREATOR_OFFERING_DATA:
      const homePayload = action.payload.ofrenda
      return {
        ...state,
        title: homePayload.title,
        text: homePayload.text,
        text2: homePayload.text2,
        options: homePayload.dedicatorias,
        modalOkTitle: homePayload.modal_title,
        modalOkText: homePayload.modal_text,
        hasOffering: action.payload.offering,
        isLogin: action.payload.login,
        error: false,
        isLoad: false
      }
    case SUCCESS_SEND_OFFERING:
      // const sendOfferingPayload = action.payload.ofrenda
      return {
        ...state,
        error: false,
        isLoad: false,
        offeringCreated: {}
      }
    case ERROR_DOWNLOAD_CREATOR_OFFERING_DATA:
      return {
        ...state,
        error: true,
        isLoad: false
      }
    case ERROR_SEND_OFFERING:
      return {
        ...state,
        error: true,
        isLoad: false
      }
    case UPDATE_TEMPORAL_IMAGE:
      return {
        ...state,
        temporalImage: action.payload
      }
    case UPDATE_CONFIRMED_IMAGE:
      return {
        ...state,
        confirmedImage: action.payload
      }
    case SHOW_CUTTER_IMAGE:
      return {
        ...state,
        isCutterImageVisible: action.payload
      }
    default:
      return {
        ...state
      }
  }
}
